import React from 'react';
import { LINK_TYPE } from '../../../../utils/constants';
import SingleIcon from '../../utils/icons/SingleIcon';

const PublicLinkItem = ({
  _id,
  title,
  link,
  strasse,
  plz,
  ort,
  telefonnummer,
  email,
  geburtstag,
  netzwerk,
  icon,
  position,
  type,
  iconColor,
  linkColor,
}) => {
  // Geburtstag umformatieren
  const date = new Date(geburtstag);
  const geburtstagFormatted = date.toLocaleDateString('ch-DE', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
  return (
    <li className="py-4 my-4 overflow-hidden bg-white rounded-lg shadow-lg hover:shadow-sm  hover:cursor-pointer hover:scale-105 transition-all">
      {type === LINK_TYPE.NOTIZEN ||
      type === LINK_TYPE.SPITZNAME ||
      type === LINK_TYPE.GEBURTSTAG ? (
        <span className="h-full w-full">
          <div className="flex">
            <div className="self-center text-4xl px-3">
              <SingleIcon
                iconComponentName={icon}
                size={40}
                color={iconColor}
              />
            </div>
            <div className="grid px-3" style={{ color: linkColor }}>
              <h3 className="self-center text-lg font-semibold">{title}</h3>
              <p className="self-center text-lg overflow-hidden whitespace-nowrap ">
                {type === LINK_TYPE.GEBURTSTAG ? geburtstagFormatted : link}
              </p>
            </div>
          </div>
        </span>
      ) : (
        <a
          className="h-full w-full"
          href={
            type === LINK_TYPE.TELEFON_PRIVAT ||
            type === LINK_TYPE.TELEFON_ARBEIT ||
            type === LINK_TYPE.TELEFON
              ? 'tel:' + telefonnummer
              : type === LINK_TYPE.EMAIL_ARBEIT ||
                type === LINK_TYPE.EMAIL_PRIVAT ||
                type === LINK_TYPE.EMAIL
              ? 'mailto:' + email
              : type === LINK_TYPE.ADRESSE_FIRMA ||
                type === LINK_TYPE.ADRESSE_PRIVAT ||
                type === LINK_TYPE.ADRESSE
              ? `https://www.google.com/maps/search/?api=1&query=${strasse} ${plz} ${ort}`
              : type === LINK_TYPE.SOCIAL_MEDIA
              ? 'https://' + link
              : link
          }
        >
          <div className="flex">
            <div className="self-center text-4xl px-3">
              <SingleIcon
                iconComponentName={icon}
                size={40}
                color={iconColor}
              />
            </div>
            <div className="grid px-3" style={{ color: linkColor }}>
              <h3 className="self-center text-lg font-semibold">{title}</h3>
              <p className="self-center text-lg overflow-hidden whitespace-nowrap ">
                {type === LINK_TYPE.TELEFON_PRIVAT ||
                type === LINK_TYPE.TELEFON_ARBEIT ||
                type === LINK_TYPE.TELEFON
                  ? telefonnummer
                  : type === LINK_TYPE.EMAIL_ARBEIT ||
                    type === LINK_TYPE.EMAIL_PRIVAT ||
                    type === LINK_TYPE.EMAIL
                  ? email
                  : type === LINK_TYPE.ADRESSE_FIRMA ||
                    type === LINK_TYPE.ADRESSE_PRIVAT ||
                    type === LINK_TYPE.ADRESSE
                  ? `${strasse} ${plz} ${ort}`
                  : type === LINK_TYPE.SOCIAL_MEDIA
                  ? 'https://' + link
                  : link}
              </p>
            </div>
          </div>
        </a>
      )}
    </li>
  );
};

export default PublicLinkItem;
